<template>
  <div class="vsmb-invite-link-copy app-copy-input-value">
    <div class="input-group">
      <input
        ref="inputValue"
        class="form-control"
        :value="value"
        readonly
        @click="selectInputText"
      />
      <span
        class="input-group-addon"
        :class="{ pressed: btnPressed, disabled: disableCopy }"
        @click.prevent="copyInputValue"
      >
        <a
          href="#"
          class="copy-link"
        >{{ btnText }}</a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VsmbInviteLinkCopy',
  props: {
    value: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      default: 'Copy',
    },
    copiedText: {
      type: String,
      default: 'Copied',
    },
  },
  data: () => ({
    btnPressed: false,
  }),
  computed: {
    disableCopy() {
      return !this.value;
    },
    btnText() {
      return this.btnPressed ? this.copiedText : this.buttonText;
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    selectInputText() {
      this.$refs.inputValue.select();
    },
    deSelectInputText() {
      this.$refs.inputValue.blur();
    },
    async copyToClipboard() {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(this.value);

        return;
      }

      this.selectInputText();
      if (!document.execCommand('copy')) {
        throw new Error('copy failed');
      }
    },
    stopCopy() {
      this.deSelectInputText();
      this.btnPressed = false;
      clearInterval(this.interval);
    },
    async copyInputValue() {
      if (this.btnPressed || this.disableCopy) {
        return;
      }

      try {
        await this.copyToClipboard();
        this.btnPressed = true;
        this.interval = setInterval(() => {
          this.stopCopy();
        }, 3000);

        window.analytics?.track('Copy to clipboard', { source: 'VSMB Getting Started' });
        this.$emit('copied');
      } catch (e) {
        this.$appMessage('There was an unexpected error');
      }
    },
  },
};
</script>
